import { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "../../assets/images/icons/ic-arrow.svg";
import { Each } from "../../common/Each";
import HeaderFooterLayout from "../../components/layouts/HeaderFooterLayout";
import typo from "../../typography.module.css";
import Button from "../Button";
import Loader from "../Loader";
import styles from "./MacroPreview.module.css";
import MacroSectionPreview from "./MacroSectionPreview";
import api from "../../api";
import PageViewer from "../builder/PageViewer";
import MacroMainPreview from "./MacroMainPreview";

const MacroPreview = () => {
    const { macroId } = useParams()
    const [macro, setMacro] = useState(null)
    const [showDetails, setShowDetails] = useState(false)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        window.scrollTo({
            top: 0,
        })
    }, [])

    useEffect(() => {
        const getMacro = async () => {
            setLoading(true)
            try {
                const macro = await api.get(`/admin/macros/${macroId}`)
                setMacro(macro)
            } catch (e) {
                console.error(e)
            }
            setLoading(false)
        }

        if (macroId) {
            getMacro()
        }
    }, [macroId])

    return (
        <HeaderFooterLayout>
            <div className={styles.container}>
                {macro && !showDetails &&
                    <>
                        <div className={styles.section} style={{ paddingTop: '1rem', borderBottom: '1px solid rgba(var(--text-color-rgb), 12%)' }}>
                            <div className={styles.sectionInner}>
                                <MacroMainPreview name={macro.name} description={macro.description} careers={macro.careers} video_url={macro.video_url} thumbnail={macro.thumbnail} />
                            </div>
                        </div>

                        {macro.content[0] &&
                            <>
                                <PageViewer page={[macro.content[1]]} />
                                <div className={styles.viewDetail}>
                                    <Button
                                        onClick={() => {
                                            setShowDetails(true)
                                        }}
                                    >
                                        LEGGI TUTTO
                                        <ArrowIcon style={{ transform: 'rotate(180deg)' }}></ArrowIcon>
                                    </Button>
                                </div>
                            </>
                        }
                    </>
                }
                {loading &&
                    <div className={styles.loader}>
                        <Loader />
                    </div>

                }
                {
                    macro && showDetails &&
                    <PageViewer page={macro.content} />
                }
            </div>
        </HeaderFooterLayout>
    )
}

export default MacroPreview
